// extracted by mini-css-extract-plugin
module.exports = {"container":"TargetDetails_container__UExDC","cell":"TargetDetails_cell__Wsv54","marker":"TargetDetails_marker__e7BSz","link":"TargetDetails_link__R11Qn"};